export const appUrl = () =>
  import.meta.env.VITE_APPLICATION_URL_OVERRIDE ??
  `${window.location.origin}${import.meta.env.VITE_ASSET_PATH}`.replace(/\/$/, '');
